import script from "./TransactionData.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionData.vue?vue&type=script&setup=true&lang=ts"

import "./TransactionData.vue?vue&type=style&index=0&id=1afad24e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1afad24e"]])

export default __exports__